import request from '@/utils/request'
const url = '/admin/generate.generate_columns'
const api = {
  GetColumnList(data) {
    return request({
      url: `${url}/getColumnList`,
      method: 'post',
      data
    })
  }
}

export default api
